import * as React from "react";
import "./checkbox-line.scss";
import {Checkbox} from "../../../../../../../common/design2/checkbox/checkbox";
import {cx} from "emotion";

export const CheckboxLine = ({state, text, textUI=undefined, xdQaName=undefined}) => (
    <div className="checkbox-line checkbox-line-14v" onClick={() => state.onChange(!state.value)}>
        {Checkbox({
            checked: state.value,
            xdQaName,
        })}

        <div className={cx("text", textUI)} xd-qa-type="label" xd-qa-name={xdQaName}>
            {text}
        </div>
    </div>
);
